import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { LoadingIndicatorComponent } from '@/app/shared/components/ui/loading-indicator';

@Component({
  selector: 'app-dialog-loader',
  imports: [LoadingIndicatorComponent],
  templateUrl: './dialog-loader.component.html',
  styleUrl: './dialog-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'dialog-loader',
  },
})
export class DialogLoaderComponent {}
